import { CONTENT_URL_PATHS } from "./content";

export const ROUTES = {
  ALL: "*",
  HOME: "/",
  LOGOUT: "/logout",
  SIGN_UP: "/signup",
  SIGN_IN: "/signin",
  NOT_FOUND: "/not-found",
  CREATE_COMPANY: "/create-company",
  UNVERIFIED: "/unverified",
  TERMS: "/terms",
  APPLICATIONS: "/applications",
  APPLY_AND_REFER: "/apply-and-refer",
  PRODUCT_SELECTOR_TOOL: "/product-selector-tool",
  PROMOTIONS: "/promotions",
  REPORTING: "/reporting",
  COMPANIES: "/companies",
  TRANSACTIONS: "/transactions",
  CREATE_QUOTE: "/create-quote",
  VIEW_QUOTE: "/:ownerId/quote/:quoteId",
  PRODUCT_SELECTOR: "/product-selector",
  PRODUCT_SELECTOR_AV: "/product-selector-av",
  WORKING_CAPITAL: "/working-capital-calculator",
  WORKING_CAPITAL_AV: "/working-capital-calculator-av",
  QUOTES: "/quotes",
  PROFILE: ["/profile", "/profile/:id"],
  ALL_USERS: "/all-users",
  PENDING_APPLICATIONS: "/pending-applications",
  FAST_DOC_SETTINGS: "/fast-doc/settings",
  LITE_DOC_SETTINGS: "/lite-doc/settings",
  ASSET_FINANCE_SELECTION: "/asset-finance",
  APPLY_ALL: "/apply-all",
  ASSET_FINANCE: [
    "/af/:docType",
    "/af/:docType/user/:brokerId",
    "/af/:docType/user/:brokerId/app/:appId",
    "/af/:docType/user/:brokerId/cust/:custId",
  ],
  BUSINESS_FUEL_SELECTION: "/business-fuel",
  BUSINESS_FUEL: [
    "/bf",
    "/bf/user/:brokerId",
    "/bf/user/:brokerId/app/:appId",
    "/bf/user/:brokerId/cust/:custId",
  ],
  BF_SUB_ROUTES: {
    BROKER: "broker",
    BUSINESS_DETAILS: "business-details",
    CLIENT_DETAILS: "client-details",
    FINANCE_NEEDS: "finance-needs",
    DOCUMENTS: "documents",
    SUCCESS: "success",
  },
  AF_SUB_ROUTES: {
    BROKER: "broker",
    BUSINESS_DETAILS: "business-details",
    CLIENT_DETAILS: "client-details",
    FINANCE_NEEDS: "finance-needs",
    DOCUMENTS: "documents",
    GUARANTORS: "guarantors",
    BANK: "bank",
    BACKGROUND: "background",
    SUCCESS: "success",
  },
  CASHLINE: {
    ROOT: [
      "cashline",
      "cashline/user/:brokerId",
      "cashline/user/:brokerId/cust/:custId",
      "/cashline/user/:brokerId/app/:appId",
    ],
    SUB_ROUTES: {
      BROKER: "broker",
      BUSINESS_DETAILS: "business-details",
      CLIENT_DETAILS: "client-details",
      FINANCE_NEEDS: "finance-needs",
      SUCCESS: "success",
    },
  },
  LINE_OF_CREDIT: {
    ROOT: [
      "line-of-credit",
      "line-of-credit/user/:brokerId",
      "line-of-credit/user/:brokerId/cust/:custId",
      "/line-of-credit/user/:brokerId/app/:appId",
    ],
    SUB_ROUTES: {
      BROKER: "broker",
      BUSINESS_DETAILS: "business-details",
      CLIENT_DETAILS: "client-details",
      FINANCE_NEEDS: "finance-needs",
      SUCCESS: "success",
    },
  },
  CLIENT_MANAGEMENT: {
    ASSET_FINANCE: {
      PAYOUT: "client-management/asset-finance/payout",
      STATEMENT: "client-management/asset-finance/statement",
    },
  },
  CONTENT_RESOURCE_MANAGEMENT: Object.values(CONTENT_URL_PATHS) as string[],
  VERIFY_EMAIL: "/verify-email",
  RESET_PASSWORD_EMAIL_VERIFY: "/reset-password/verify-email",
  RESET_PASSWORD: "/reset-password",
};
